const typography = {
  fontFamily: [
    // 'Public Sans',
    // 'sans-serif',
    // '-apple-system',
    // 'BlinkMacSystemFont',
    // '"Segoe UI"',
    // 'Roboto',
    // '"Helvetica Neue"',
    // 'Arial',
    // 'sans-serif',
    // '"Apple Color Emoji"',
    // '"Segoe UI Emoji"',
    // '"Segoe UI Symbol"',
    '"Inter"',
  ].join(','),
  fontSize: 14,
  h1: {
    fontWeight: 600,
    fontSize: '1.506em',
    lineHeight: 1.368421,
  },
  h2: {
    fontWeight: 500,
    fontSize: '1.3em',
    lineHeight: 1.375,
  },
  h3: {
    fontWeight: 500,
    lineHeight: 1.38462,
    fontSize: '1.625em',
  },
  h4: {
    fontWeight: 500,
    lineHeight: 1.364,
    fontSize: '1.375em',
  },
  h5: {
    lineHeight: 1.3334,
    fontSize: '1.225em',
    fontWeight: 500,
  },
  h6: {
    lineHeight: '1.1334',
    fontSize: '20px',
    fontWeight: 500,
  },
  subtitle1: {
    fontSize: '1em',
    // letterSpacing: '0.15px',
  },
  subtitle2: {
    // lineHeight: 1.32,
    fontSize: '0.9em',
    fontWeight: 500,
  },
  body1: {
    fontSize: '0.9334em',
    // lineHeight: '14px',
    fontWeight: 300,
  },
  body2: {
    fontSize: '0.9334em',
    // lineHeight: '14px',
    fontWeight: 400,
  },
  button: {
    lineHeight: 1.2,
    fontSize: '0.9375em',
    letterSpacing: '0.43px',
  },
  caption: {
    lineHeight: 1.273,
    fontSize: '0.75em',
  },
  overline: {
    fontSize: '0.75em',
    letterSpacing: '1px',
  },
}

export default typography
